export enum AppPlatform {
    MOBILE      = "mobile", // mobile APP i.e. native andorid or iphone
    ELECTRON    = "electron",
    BROWSER     = "browser"
}

export enum ScheduleStatus {
    NOT_SCHEDULED   = 0,
    SCHEDULED       = 1,
    SOMEDAY         = 2
}


export type Priority = 1 | 2 |3 |4|5|6|7|8|9|10|50|100


export enum DayOfWeekName {
    MON = 'mon',
    TUE = 'tue',
    WED = 'wed',
    THU = 'thu',
    FRI = 'fri',
    SAT = 'sat',
    SUN = 'sun'
}

export type DaysOfWeek = {
    [DayOfWeekName.MON] : boolean
    [DayOfWeekName.TUE] : boolean
    [DayOfWeekName.WED] : boolean
    [DayOfWeekName.THU] : boolean
    [DayOfWeekName.FRI] : boolean
    [DayOfWeekName.SAT] : boolean
    [DayOfWeekName.SUN] : boolean
}

export type BinaryWeek = [
    0 | 1, 0 | 1, 0 | 1, 0 | 1, 0 | 1, 0 | 1, 0 | 1
]

